import type { JSX } from 'react'
import { dismissToast, useToasts } from '../lib/toast'

export function Toasts(): JSX.Element | null {
  const toasts = useToasts()
  if (toasts.length === 0) return null
  return (
    <div className="toasts">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast ${toast.kind}`} role="status">
          <span style={{ flex: 1 }}>{toast.text}</span>
          <button type="button" onClick={() => dismissToast(toast.id)} title="Закрыть">
            ✕
          </button>
        </div>
      ))}
    </div>
  )
}
